import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full overflow-x-hidden overflow-y-auto min-h-[90vh] max-h-[90vh]" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4 border-b border-gray-200 bg-white px-4 py-5 sm:px-6 sticky top-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold text-gray-900" }, "Learner Product License Allocation", -1)
const _hoisted_4 = { class: "flex gap-x-4 mr-8" }
const _hoisted_5 = { class: "mb-4 flex items-center justify-between text-sm" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "w-full bg-gray-200 rounded-full h-2 dark:bg-gray-700" }
const _hoisted_8 = { class: "w-full pb-28" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex justify-between items-center w-full" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "font-semibold mr-2" }
const _hoisted_13 = { class: "bg-blue-50 border border-blue-200 rounded-full py-1 px-2 w-[90px] text-center text-blue-600 text-xs font-medium mr-4" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "text-gray-600 font-semibold text-sm" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "px-4" }
const _hoisted_20 = { class: "flex justify-between items-center w-full mb-6" }
const _hoisted_21 = { class: "w-2/3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, " Classes ", -1)
const _hoisted_23 = { class: "flex flex-row flex-wrap" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "relative" }
const _hoisted_26 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-600 font-medium text-sm mb-2" }, " Select product licenses to allocate to learners. ", -1)
const _hoisted_28 = { class: "min-w-full w-full" }
const _hoisted_29 = { class: "columns" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { class: "border-y border-y-gray-200 border-l border-l-gray-200 py-3 text-gray-600 font-medium text-xs text-start pl-6 rounded-tl-lg" }, " First Name ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", { class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start" }, " Last Name ", -1)
const _hoisted_32 = ["value", "checked", "indeterminate", "onChange"]
const _hoisted_33 = { class: "text-gray-900 text-sm font-medium py-6 border-b border-b-gray-200 pl-6 border-l border-l-gray-200" }
const _hoisted_34 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_35 = ["value", "checked", "onChange", "disabled"]
const _hoisted_36 = { class: "pagination w-full text-center my-8" }
const _hoisted_37 = ["onClick", "disabled"]

import { Learner } from '@/interfaces/learner.interface';
import { License } from '@/interfaces/license.interface';
import { SchoolStructureClassGroup } from '@/interfaces/school-structure.interface';
import { useLearnerStore } from '@/stores/learnerStore';
import { useLicenseStore } from '@/stores/licenseStore';
import { useProductStore } from '@/stores/productStore';
import { useSchoolStore } from '@/stores/schoolStore';
import { computed, onBeforeMount, watch } from 'vue';
import { PropType, ref } from 'vue';

// Stores
const learnersPerPage = 8;
const maxVisiblePages = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'LearnersLicenseAllocationTableComponent',
  props: {
  licenseToAllocate: {
    type: Object as PropType<License>,
    required: true,
  },
  gradeLevel: {
    type: Number,
    required: true
  }
},
  emits: ["updateAssignments", "close"],
  setup(__props, { emit }) {

const props = __props;

const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();
const productStore = useProductStore();
const licenseStore = useLicenseStore();



// Emits


// Local State
const currentPage = ref(1);
const searchQuery = ref("");
const classFilter = ref("");
const currentOpenGrade = ref<number | undefined>(0);
// Learner Product Assignments
const learnerProductAssignments = ref<{ [key: string]: string[] }>({});

// Create a computed property for visibleGrades
const visibleGrades = computed(() => {
  const allGrades = schoolStore.currentSchoolStructure?.gradeLevels || [];
  // Filter out grades with no learners
  return allGrades.filter((grade: number) => getLearnersByGrade(grade).length > 0);
});

const learners = computed<Learner[]>(() => {
  return learnerStore.getSchoolLearners.filter(
    (learner) =>
      learner.grade === currentOpenGrade.value && learner.status === "active"
  );
});

const classGroups = computed<SchoolStructureClassGroup[]>(() => {
  return schoolStore.currentSchoolStructure?.classGroups.filter(
    (classGroup) => {
      return classGroup.gradeLevel === currentOpenGrade.value;
    }
  ) || [];
});

const availableProducts = computed(() => {
  // return productStore.products;
  return props.licenseToAllocate.products
});

const productSeatsUsage = computed(() => {
  const usage: { [key: string]: number } = {};

  // Start with the seatsUsed from the license
  props.licenseToAllocate.products.forEach(product => {
    usage[product._id] = product.seatsUsed || 0;
  });

  // Add the new assignments from learnerProductAssignments
  Object.values(learnerProductAssignments.value).forEach(productIds => {
    productIds.forEach(productId => {
      if (usage[productId] !== undefined) {
        usage[productId] += 1;
      } else {
        usage[productId] = 1;
      }
    });
  });

  return usage;
});

const licenseProgress = computed(
  () => (product: any) =>
    Math.round((productSeatsUsage.value[product._id] / product.maxSeats) * 100)
);

// Methods to manage product assignments
const isProductAssignedToLearner = (productId: string, learnerId: string) => {
  return learnerProductAssignments.value[learnerId]?.includes(productId);
};

const toggleProductAssignment = (productId: string, learnerId: string, event: Event, showAlert = true) => {
  const target = event.target as HTMLInputElement | null;

  if (!target) return;
  
  const isChecked = target.checked;

  const product = props.licenseToAllocate.products.find(p => p._id === productId);

  if (!product) return;

  const currentAssignedSeats = productSeatsUsage.value[productId] || 0;

  if (isChecked) {
    if (currentAssignedSeats >= product.maxSeats) {
      // Cannot assign more licenses than maxSeats
      if (showAlert) alert(`Cannot assign more licenses for ${product.title}. Max seats reached.`);
      return;
    }
    if (!learnerProductAssignments.value[learnerId]) {
      learnerProductAssignments.value[learnerId] = [];
    }
    if (!learnerProductAssignments.value[learnerId].includes(productId)) {
      learnerProductAssignments.value[learnerId].push(productId);
    }
  } else {
    if (learnerProductAssignments.value[learnerId]) {
      learnerProductAssignments.value[learnerId] = learnerProductAssignments.value[learnerId].filter(
        (id) => id !== productId
      );
      if (learnerProductAssignments.value[learnerId].length === 0) {
        delete learnerProductAssignments.value[learnerId];
      }
    }
  }
};

const getLearnersByGrade = (grade: any) => {
  return learnerStore.schoolLearners.filter((learner) =>
    (learner.grade === grade) && (learner.status === 'active')
    // learner.classes.some((classGroup) => classGroup.gradeLevel === grade)
  );
};

const getLearnerClassForSubject = (learner: Learner, subjectCode: string) => {
  const classObj = learner.classes.find(c => c.subject?.code === subjectCode);
  return classObj ? classObj.name : '-';
};

// Watch for changes and emit updates
watch(
  learnerProductAssignments,
  () => {
    emit("updateAssignments", learnerProductAssignments.value);
  },
  { deep: true }
);

// Computed properties
const filteredLearners = computed(() => {
  const query = searchQuery.value.toLowerCase();

  const learnersFilteredByName = learners.value.filter(
    (row) =>
      row.lastName.toLowerCase().includes(query) ||
      row.firstName.toLowerCase().includes(query)
  );

  const learnersFilteredByClass = classFilter.value
    ? learnersFilteredByName.filter((row) =>
        row.classes.some((c) => c._id == classFilter.value)
      )
    : learnersFilteredByName;

  return learnersFilteredByClass;
});

const filteredAndPaginatedLearners = computed(() => {
  const start = (currentPage.value - 1) * learnersPerPage;
  return filteredLearners.value.slice(start, start + learnersPerPage);
});

// Pagination
const totalPages = computed(() =>
  Math.ceil(filteredLearners.value.length / learnersPerPage)
);

const goToPage = (pageNumber: number) => {
  currentPage.value = pageNumber;
};

const visiblePages = computed(() => {
  let start = Math.max(currentPage.value - Math.floor(maxVisiblePages / 2), 1);
  let end = Math.min(start + maxVisiblePages - 1, totalPages.value);

  if (end >= totalPages.value) {
    start = Math.max(totalPages.value - maxVisiblePages + 1, 1);
  }

  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
});

// Watchers
watch(searchQuery, () => {
  currentPage.value = 1;
});

watch(classFilter, () => {
  currentPage.value = 1;
});

// Select All Learners
const isProductFullyAssigned = (productId: string) => {
  const totalLearners = filteredLearners.value.length;
  const assignedLearners = filteredLearners.value.filter((learner) =>
    isProductAssignedToLearner(productId, learner._id)
  ).length;
  return totalLearners > 0 && assignedLearners === totalLearners;
};

const isProductPartiallyAssigned = (productId: string) => {
  const totalLearners = filteredLearners.value.length;
  const assignedLearners = filteredLearners.value.filter((learner) =>
    isProductAssignedToLearner(productId, learner._id)
  ).length;
  return assignedLearners > 0 && assignedLearners < totalLearners;
};

const toggleSelectAll = (productId: string, event: Event) => {
  const target = event.target as HTMLInputElement | null;

  if (!target) return;

  const isChecked = target.checked;

  const product = props.licenseToAllocate.products.find(
    (p) => p._id === productId
  );
  if (!product) return;

  const currentAssignedSeats = productSeatsUsage.value[productId] || 0;
  const remainingSeats = product.maxSeats - currentAssignedSeats;

  if (isChecked) {
    // Assign to all learners, respecting max seats
    const learnersToAssign = filteredLearners.value.filter(
      (learner) => !isProductAssignedToLearner(productId, learner._id)
    );

    const seatsAvailable = Math.min(remainingSeats, learnersToAssign.length);
    const learnersToAssignLimited = learnersToAssign.slice(0, seatsAvailable);

    learnersToAssignLimited.forEach((learner) => {
      toggleProductAssignment(productId, learner._id, event, false);
    });
    if (learnersToAssign.length > seatsAvailable) {
      alert(
        `Only ${seatsAvailable} learners will be assigned due to max seats limit for ${product.title}.`
      );
    }
  } else {
    // Unassign from all learners
    filteredLearners.value.forEach((learner) => {
      toggleProductAssignment(productId, learner._id, event, false);
    });
  }
};

const submitAssignments = async () => {
  try {
    await licenseStore.saveLearnerProductAssignments(
      props.licenseToAllocate._id,
      learnerProductAssignments.value
    );
    
    emit("close");
  } catch (error) {
    console.error("Error submitting assignments:", error);
    alert("Failed to submit assignments. Please try again.");
  }
};

const cancelModal = () => {
  emit("close");
}

watch(
  learners,
  (newLearners) => {
    // Re-initialize assignments when learners change
    console.log("new learners changed: ", newLearners)
    newLearners.forEach((learner) => {
      if (!(learner._id in learnerProductAssignments.value)) {
        learnerProductAssignments.value[learner._id] = [];
      }
    });
  },
  { immediate: true }
);

const normalizeAssignments = (assignments: { [key: string]: string[] }, learners: Learner[]) => {
  const result = { ...assignments };
  learners.forEach(learner => {
    if (!result[learner._id]) {
      result[learner._id] = [];
    }
  });
  return result;
}

onBeforeMount(() => {
  // Initialize learnerProductAssignments with existing data if available
  if (props.licenseToAllocate.learnerProductAssignments) {
    learnerProductAssignments.value = normalizeAssignments(
      props.licenseToAllocate.learnerProductAssignments || {},
      learners.value
    );
  } else {
    // If no existing assignments, initialize with empty arrays
    learners.value.forEach((learner) => {
      learnerProductAssignments.value[learner._id] = [];
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_MagnifyingGlassIcon = _resolveComponent("MagnifyingGlassIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableProducts.value, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            key: product.title,
            class: "w-52"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h5", _hoisted_6, _toDisplayString(product.title), 1),
              _createElementVNode("h5", null, _toDisplayString(productSeatsUsage.value[product._id] || 0) + "/" + _toDisplayString(product.maxSeats), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "bg-blue-600 h-2 rounded-full",
                style: _normalizeStyle({ width: licenseProgress.value(product) + '%' })
              }, null, 4)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleGrades.value, (grade) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "px-4",
          key: grade
        }, [
          _createElementVNode("button", {
            onClick: ($event: any) => (
            currentOpenGrade.value == grade
              ? (currentOpenGrade.value = 0)
              : (currentOpenGrade.value = grade)
          ),
            class: "accordion-title flex flex-col rounded-lg bg-white border border-gray-200 mb-4 w-full px-4 py-4"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.grade")) + " " + _toDisplayString(grade), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", null, _toDisplayString(getLearnersByGrade(grade).length) + " " + _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.students")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.view")), 1),
                (currentOpenGrade.value == grade)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-dark-arrow-down',
                        title: 'rl dark arrow down',
                        "aria-hidden": "true"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-dark-arrow-up',
                        title: 'rl dark arrow up',
                        "aria-hidden": "true"
                      })
                    ]))
              ])
            ])
          ], 8, _hoisted_9),
          (currentOpenGrade.value == grade)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (classFilter.value = '')),
                          class: _normalizeClass(['bg-blue-50 rounded-lg px-4 py-2 text-sm font-medium me-2 mb-2 border', { 'text-blue-600 border-blue-600': classFilter.value === '', 'text-gray-500': classFilter.value !== '' }])
                        }, " All ", 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classGroups.value, (classGroup, id) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: id,
                            onClick: ($event: any) => (classFilter.value = classGroup._id),
                            class: _normalizeClass([
                      'bg-blue-50 rounded-lg px-2 py-2 text-sm font-medium me-2 mb-2 border',
                      { 'text-blue-600 border-blue-600': classFilter.value === classGroup._id, 'text-gray-500': classFilter.value !== classGroup._id }
                      ])
                          }, _toDisplayString(classGroup.name), 11, _hoisted_24))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_MagnifyingGlassIcon, {
                          class: "h-5 w-5 text-gray-400",
                          "aria-hidden": "true"
                        })
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "search",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                        placeholder: "Search student",
                        class: "border border-gray-300 rounded-lg py-1.5 pl-10 pr-10 me-10 w-full text-sm leading-6"
                      }, null, 512), [
                        [_vModelText, searchQuery.value]
                      ])
                    ])
                  ]),
                  _hoisted_27,
                  _createElementVNode("table", _hoisted_28, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_29, [
                        _hoisted_30,
                        _hoisted_31,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).products, (product) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: product._id + '-class',
                            class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-center"
                          }, _toDisplayString(product.subject.name) + " Class ", 1))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableProducts.value, (product) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: product._id + '-license',
                            class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-center"
                          }, [
                            _createTextVNode(_toDisplayString(product.title) + " ", 1),
                            _createElementVNode("input", {
                              type: "checkbox",
                              value: product._id,
                              checked: isProductFullyAssigned(product._id),
                              indeterminate: isProductPartiallyAssigned(product._id),
                              onChange: ($event: any) => (toggleSelectAll(product._id, $event)),
                              class: "ml-2 h-4 w-4 border border-blue-600"
                            }, null, 40, _hoisted_32)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAndPaginatedLearners.value, (learner) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: learner._id,
                          class: "mb-1"
                        }, [
                          _createElementVNode("td", _hoisted_33, _toDisplayString(learner.firstName), 1),
                          _createElementVNode("td", _hoisted_34, _toDisplayString(learner.lastName), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).products, (product) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: product._id + '-class',
                              class: "text-center py-6 border-b border-b-gray-200"
                            }, _toDisplayString(getLearnerClassForSubject(learner, product.subject.code)), 1))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableProducts.value, (product) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: product._id + '-license',
                              class: "text-center py-6 border-b border-b-gray-200"
                            }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                value: product._id,
                                checked: isProductAssignedToLearner(product._id, learner._id),
                                onChange: ($event: any) => (toggleProductAssignment(product._id, learner._id, $event)),
                                disabled: !isProductAssignedToLearner(product._id, learner._id) && productSeatsUsage.value[product._id] >= product.maxSeats,
                                class: "h-4 w-4 border border-blue-600 disabled:border-red-500"
                              }, null, 40, _hoisted_35)
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (pageNumber) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: pageNumber,
                        onClick: ($event: any) => (goToPage(pageNumber)),
                        disabled: pageNumber === currentPage.value,
                        class: "text-gray-700 p-2.5 text-xs font-medium me-2.5 rounded-lg leading-none pag-btn border border-gray-300 disabled:border-blue-600 bg-white disabled:bg-blue-200"
                      }, _toDisplayString(pageNumber), 9, _hoisted_37))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", { class: "w-full flex items-center gap-x-4 justify-end px-4 py-4 sm:px-6 border-t border-gray-200 bg-white fixed bottom-0" }, [
      _createElementVNode("button", {
        type: "button",
        onClick: cancelModal,
        class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
      }, " Cancel "),
      _createElementVNode("button", {
        onClick: submitAssignments,
        class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-blue-600 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
      }, " Submit ")
    ])
  ]))
}
}

})